import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { StepsIndicator } from 'src/components/StepsIndicator';
import { SText } from 'src/components/SText';
import { CreateClientFormContainer } from '../../containers';
import {
  eStoreAgenciesForSelectSelector,
  eStoreFormReceiverSelector,
  eStoreFormStateSelector,
  eStoreSenderIsNotReceiverSelector,
  setEStoreReceiver,
} from '../store';

type Props = {
  parentUrl: string;
};

export const EStoreReceiver = ({ parentUrl }: Props) => {
  const history = useHistory();

  const dispatch = useDispatch();

  const receiverForm = useSelector(eStoreFormReceiverSelector);
  const senderIsNotReceiver = useSelector(eStoreSenderIsNotReceiverSelector);

  const agencies = useSelector(eStoreAgenciesForSelectSelector);
  const eStoreForm = useSelector(eStoreFormStateSelector);

  useEffect(() => {
    if (!eStoreForm.sender.tel || !eStoreForm.toAgency) {
      history.replace(`${parentUrl}/information`);
    }
  }, [eStoreForm, history, parentUrl]);

  const onSubmit = useCallback(() => {
    history.push(`${parentUrl}/details`);
  }, [history, parentUrl]);

  const onFieldsUpdate = useCallback(
    (data) => {
      dispatch(setEStoreReceiver({ receiver: data }));
    },
    [dispatch],
  );

  const onPreview = useCallback(() => {
    history.goBack();
  }, [history]);

  return (
    <div className="h-screen py-3 md:h-auto md:mt-0 mt-6 w-full relative">
      <StepsIndicator totalSteps={senderIsNotReceiver ? 4 : 3} active={1} />
      <SText
        label="estore-receiver.page-title"
        classNames="my-3 text-primary block text-lg text-center font-semibold"
      />
      <CreateClientFormContainer
        agencies={agencies}
        onSubmit={onSubmit}
        requiredToAgency={false}
        onFieldsUpdate={onFieldsUpdate}
        defaultValues={receiverForm ?? {}}
        onPreview={onPreview}
      ></CreateClientFormContainer>
    </div>
  );
};
